import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=03d52279&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
import style0 from "./EventList.vue?vue&type=style&index=0&id=03d52279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d52279",
  null
  
)

export default component.exports